import {
  setAccessToken,
  setRefreshToken,
  setEduBureauId,
  getAccessToken,
  getRefreshToken,
  getEduBureauId,
} from '@/utils/storage'
import { $request } from '@/api'

let refreshTimer = null
let loginInfoStation = null

export default {
  state: {
    accessToken: getAccessToken(),
    refreshToken: getRefreshToken(),
    userInfo: null,
    eduBureauInfo: null,
    eduBureauId: getEduBureauId(),
    manageEduBureauList: [],
    semesterInfo: null,
    semesterList: []
  },
  mutations: {
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken
      setAccessToken(accessToken)
    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
      setRefreshToken(refreshToken)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setEduBureauInfo(state, eduBureauInfo) {
      state.eduBureauInfo = eduBureauInfo
    },
    setEduBureauId(state, id) {
      state.eduBureauId = id
      setEduBureauId(id)
    },
    setManageEduBureauList(state, list) {
      state.manageEduBureauList = list
    },
    setSemesterInfo(state, info) {
      state.semesterInfo = info
    },
    setSemesterList(state, list) {
      state.semesterList = list
    }
  },
  actions: {
    login({ commit, dispatch }, { loginFunc, data }) {
      return $request(loginFunc, data).then(({ data }) => dispatch('checkUserAppList', data))
    },
    wxLogin({ commit, dispatch }, data) {
      return $request('getWXAuthentication', data).then(({ data }) => dispatch('checkUserAppList', data))
    },
    wxBindUser({ commit, dispatch }, data) {
      return $request('bindPhoneAnd3rdParty', data).then(({ data }) => dispatch('checkUserAppList', data))
    },
    checkUserAppList({ dispatch }, data) {
      const appNum = data.optionalAppList?.length
      if (appNum) {
        appNum === 1 ? dispatch('loginSuccess', data) : dispatch('loginPause', data)
      }
      return data
    },
    loginSuccess({ commit, dispatch, state }, data) {
      commit('setAccessToken', data.accessToken)
      commit('setRefreshToken', data.refreshToken)
    },
    loginPause(_, data) {
      loginInfoStation = data
    },
    setUserApp({ state, dispatch }, params) {
      const headers = loginInfoStation ? { Authorization: 'Bearer ' + loginInfoStation.accessToken } : {}
      return $request('setUserApp', params, headers).then(() => {
        loginInfoStation && dispatch('loginSuccess', loginInfoStation)
        loginInfoStation = null
      })
    },
    getUserInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        $request('getUserInfo').then(async ({ data }) => {
          commit('setUserInfo', data)
          await dispatch('getEduBureauInfo')
          await dispatch('gradeAndSubject/getSubjectList')
          dispatch('startTimer')
          resolve()
        }).catch(reject)
      })
    },
    async getEduBureauInfo({ state, commit }) {
      let eduBureauId = state.userInfo.orgReferenceId
      await $request('eduBureauDetail', {}, { dynamicUrl: '/' + eduBureauId }).then(({ data }) => {
        commit('setEduBureauInfo', data)
        commit('setEduBureauId', data.id)
      })
      await $request('getSemesterList', { cityId: state.eduBureauInfo.cityId }).then(({ data }) => {
        const semesterList = data.map(i => ({
          id: i.id,
          name: `${i.year}-${i.semesterName}`,
          current: Boolean(i.currentSemester),
          start: i.semesterStartDate,
          end: i.semesterEndDate,
          year: i.year,
          semesterName: i.semesterName
        })).sort((a, b) => b.id - a.id)
        const semester = semesterList.length > 0 ? (semesterList.find(i => i.current) || semesterList[0]) : {}
        commit('setSemesterInfo', semester)
        commit('setSemesterList', semesterList)
      })
    },
    getUserManageEduBureauList({ state, commit }) {
      let userId = ''
      let accessToken = ''
      if (state.userInfo) {
        userId = state.userInfo.userId
      } else if (loginInfoStation) {
        userId = loginInfoStation.userId
        accessToken = 'Bearer ' + loginInfoStation.accessToken
      }
      return $request('userManageEduBureauList', {}, { Authorization: `${accessToken}` }).then(({ data }) => {
        commit('setManageEduBureauList', data.optionalAppList.map(i => ({ name: i.appName.replace('大屏', ''), id: i.appId })))
      }).catch(() => {})
    },
    refreshToken({ commit, dispatch, state }, getInfo = true) {
      return new Promise((resolve, reject) => {
        $request('refreshToken', {}, { headers: { RefreshToken: state.refreshToken } }).then(async res => {
          if (res.success) {
            const data = res.data
            commit('setAccessToken', data.accessToken)
            commit('setRefreshToken', data.refreshToken)
            if (getInfo) await dispatch('getUserInfo')
            resolve()
          } else {
            reject()
          }
        }).catch(reject)
      })
    },
    startTimer({ dispatch }) {
      clearTimeout(refreshTimer)
      console.log('定时刷新开启')
      refreshTimer = setInterval(() => { // 3分钟一次自动刷新用户token
        dispatch('refreshToken', false)
      }, 180000)
    },
    logoutActive({ dispatch }) {
      dispatch('logoutPassive')
    },
    logoutPassive({ commit }) {
      commit('setAccessToken', '')
      commit('setRefreshToken', '')
      commit('setEduBureauId', '')
      commit('setUserInfo', null)
      commit('clearEvent')
      clearTimeout(refreshTimer)
    }
  }
}
